import { SORT_DIRECTION, WIDGET_MODES, AGENT_STATUSES, DATA_LOADING_STATES, METRIC_NAMES } from '@config/Consts';
import { BOT_LIST_RESOURCES } from './Consts';

export default {
  dataStatus: {
    [BOT_LIST_RESOURCES.MESSAGING_CSAT_DISTRIBUTIONS]: DATA_LOADING_STATES.NONE,
    [BOT_LIST_RESOURCES.AGENT_VIEW]: DATA_LOADING_STATES.NONE,
    [BOT_LIST_RESOURCES.METRICS]: DATA_LOADING_STATES.NONE,
    [BOT_LIST_RESOURCES.HISTORICAL]: DATA_LOADING_STATES.NONE,
  },
  lastTimeDataUpdated: {
    [BOT_LIST_RESOURCES.MESSAGING_CSAT_DISTRIBUTIONS]: null,
    [BOT_LIST_RESOURCES.AGENT_VIEW]: null,
    [BOT_LIST_RESOURCES.METRICS]: null,
    [BOT_LIST_RESOURCES.HISTORICAL]: null,
  },
  botsMetrics: null,
  lastResponses: {
    [BOT_LIST_RESOURCES.MESSAGING_CSAT_DISTRIBUTIONS]: [],
    [BOT_LIST_RESOURCES.METRICS]: [],
  },
  currentPageBotIds: [],
  filter: {
    status: [],
    bots: [],
  },
  widgetMode: WIDGET_MODES.TABLE,
  botStatusSummary: {
    [AGENT_STATUSES.AWAY]: null,
    [AGENT_STATUSES.ONLINE]: null,
    [AGENT_STATUSES.BACK_SOON]: null,
  },
  sort: {
    columnName: METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS,
    direction: SORT_DIRECTION.DESCENDING,
  },
  graphActivated: false,
  graphFocusBotId: null,
  graphMetrics: null,
  graphSelectedLegend: {},
  graphWidth: '',
};
